/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import { createHead } from '@unhead/vue/client'
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// Plugins
import { registerPlugins } from '@/plugins'

(async () => {
    const app = createApp(App)
    const head = createHead()

    app.use(head)

    await registerPlugins(app) // Await plugins inside the IIFE

    app.mount('#app') // Mount the app after plugins are registered
})()